import PersonIcon from "@mui/icons-material/Person";
import { Card, CardContent, Stack, Typography } from "@mui/material";

import { NewTabLink } from "components/NewTabLink";
import { useCompanyProfile } from "hooks";
import { getCompanyProfilePath } from "utils";

interface Props {
  shipment: SupplierShipment | undefined;
}

export function BookedCarrierSection(props: Props) {
  const { shipment } = props;

  const companyId = shipment?.booked_carrier?.company ?? null;
  const { companyProfile } = useCompanyProfile(companyId);

  if (!shipment?.info?.booked_at || !shipment?.booked_carrier) {
    return null;
  }

  const carrierUser = shipment.booked_carrier.user;

  return (
    <Card sx={{ flex: 1, minWidth: "300px", boxShadow: 1 }}>
      <CardContent>
        <Stack direction="column" spacing={2}>
          <Typography variant="h6">Carrier</Typography>

          <Stack direction="column" spacing={1}>
            <Typography variant="body1" fontWeight="bold">
              {companyProfile?.company?.name}
            </Typography>

            <Stack direction="row" alignItems="flex-start" spacing={1}>
              <PersonIcon color="primary" fontSize="small" sx={{ mt: 0.5 }} />
              <Stack direction="column">
                <Typography variant="body1">
                  {carrierUser.first_name} {carrierUser.last_name}
                </Typography>
                {companyId && (
                  <NewTabLink href={getCompanyProfilePath(companyId)}>
                    <Typography>View Carrier Profile</Typography>
                  </NewTabLink>
                )}
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
